import './App.css';
import TVChartContainer from './component/TVChartContainer';
import { useEffect } from 'react';
import ChartErrorBoundary from './components/ChartErrorBoundary';

function App() {
	useEffect(() => {
		// Keep all console methods in development
		// In production, Logger utility will handle conditional logging
		
		// Optional: Setup any global error handlers here
		if (process.env.NODE_ENV === 'production') {
			// Setup Sentry or other error tracking if needed
			// window.addEventListener('error', handleGlobalError);
			// window.addEventListener('unhandledrejection', handlePromiseRejection);
		}
	}, []);

	return (
		<ChartErrorBoundary>
			<div className="App">
				<TVChartContainer />
			</div>
		</ChartErrorBoundary>
	);
}

export default App;
